'use client';

import style from './Header.module.scss';
import { Navbar } from './components/Navbar/Navbar';
import { Logo } from './components/Logo/Logo';
import { MobileMenu } from './components/MobileMenu/MobileMenu';
import { useEffect, useState } from 'react';

export const Header = () => {
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 40;
      if (isScrolled !== hasScrolled) {
        setHasScrolled(isScrolled);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [hasScrolled]);

  return (
    <header>
      <div style={{ boxShadow: hasScrolled ? '0px 16px 24px 0px rgba(0, 0, 0, 0.1)' : 'none', zIndex: '1002' }} className={style.block}>
        <section className={style.container}>
          <div className={style.header}>
            <div
              style={{
                display: 'flex',
              }}
            >
              <Logo />
            </div>

            <Navbar />
            <div className={style.mobile}>
              <MobileMenu />
            </div>
          </div>
        </section>
      </div>
      <div className={style.padding}></div>
    </header>
  );
};
